// extracted by mini-css-extract-plugin
module.exports = {"label":"P_b7","text":"P_cB"};